module.exports = __webpack_public_path__ + "static/media/consignee_holiday_template.a348a13d.csv";